/**
 * 카트 팝업 - 구매 제한 체크 (계정당 + 주문당 둘 다)
 *
 * 두 종류의 제한:
 *   accountMax = data-purchase-limit-max (custom.purchase_limit_max_per_account) — 계정당 누적+카트 합
 *   orderMax   = data-order-limit-max (custom._purchase_quantity_limit) — 주문당 카트 한도
 * 효과적 available = min(accountMax - purchased, orderMax)
 */

function getPopupEffectiveAvailable({ accountMax, purchased, orderMax }) {
  const candidates = [];
  if (accountMax && !isNaN(accountMax)) {
    candidates.push(Math.max(0, accountMax - (purchased || 0)));
  }
  if (orderMax && !isNaN(orderMax)) {
    candidates.push(orderMax);
  }
  if (candidates.length === 0) return Infinity;
  return Math.min(...candidates);
}

async function applyPopupPurchaseLimits() {
  try {
    const cartPopupItems = document.querySelectorAll('[data-cart-items-popup]');
    if (!cartPopupItems || cartPopupItems.length === 0) return;

    // 상품별 카트 내 총 수량 집계
    const res = await fetch('/cart.js');
    const cartData = await res.json();
    const productQtyMap = {};
    cartData.items.forEach(item => {
      const pid = item.product_id.toString();
      productQtyMap[pid] = (productQtyMap[pid] || 0) + item.quantity;
    });

    // API에서 current_count 조회
    let apiResults = null;
    const productIds = Object.keys(productQtyMap);
    if (productIds.length > 0 && window.CustomApi?.checkPurchaseLimit) {
      try {
        const customerId = document.querySelector('[customer-main-id]')?.getAttribute('customer-main-id');
        const customerEmail = document.querySelector('.as-salomon__cartPopup')?.getAttribute('data-customer-email')
          || document.querySelector('cart-form')?.getAttribute('data-customer-email');
        const limitRes = await window.CustomApi.checkPurchaseLimit(productIds, customerId, customerEmail);
        const rawResults = (await limitRes.json()).results || null;
        // API는 gid://shopify/Product/123 형식 → 숫자 ID로 변환
        if (rawResults) {
          apiResults = {};
          for (const [gid, value] of Object.entries(rawResults)) {
            apiResults[gid.replace('gid://shopify/Product/', '')] = value;
          }
        }
      } catch (e) {
        console.error('[PurchaseLimit] Popup API error:', e);
      }
    }

    // 각 아이템의 + 버튼 상태 업데이트
    cartPopupItems.forEach(item => {
      const productId = item.getAttribute('product-id');
      const plusBtn = item.querySelector('[data-cart-popup-item-quantity-plus]');
      if (!plusBtn) return;

      const accountMax = parseInt(item.getAttribute('data-purchase-limit-max'), 10);
      const orderMax = parseInt(item.getAttribute('data-order-limit-max'), 10);
      const hasAccount = accountMax && !isNaN(accountMax);
      const hasOrder = orderMax && !isNaN(orderMax);
      if (!hasAccount && !hasOrder) return; // 두 메타필드 모두 미설정

      const purchased = apiResults?.[productId]?.current_count || 0;
      const available = getPopupEffectiveAvailable({
        accountMax: hasAccount ? accountMax : null,
        purchased,
        orderMax: hasOrder ? orderMax : null,
      });
      const cartQty = productQtyMap[productId] || 0;
      const isLimited = cartQty >= available;

      // alert 메시지에서 어느 제한이 binding인지 구분하기 위한 효과적 max 계산
      const effectiveMax = hasAccount && hasOrder
        ? Math.min(accountMax, orderMax)
        : (hasAccount ? accountMax : orderMax);

      console.log('[PurchaseLimit] Popup -', productId,
                  '| accountMax:', accountMax, '| purchased:', purchased, '| orderMax:', orderMax,
                  '| available:', available, '| cartQty:', cartQty, '| limited:', isLimited);

      if (isLimited) {
        plusBtn.setAttribute('data-purchase-limited', '');
        plusBtn.setAttribute('data-limit-max', String(effectiveMax));
        plusBtn.setAttribute('data-limit-purchased', String(hasAccount ? purchased : 0));
        plusBtn.setAttribute('data-limit-cart-qty', String(cartQty));
        // pointer-events는 두지 않음 — 클릭이 차단되면 alert을 띄울 수 없음
        plusBtn.style.opacity = '0.5';
        plusBtn.style.cursor = 'not-allowed';
      } else {
        plusBtn.removeAttribute('data-purchase-limited');
        plusBtn.removeAttribute('data-limit-max');
        plusBtn.removeAttribute('data-limit-purchased');
        plusBtn.removeAttribute('data-limit-cart-qty');
        plusBtn.style.opacity = '';
        plusBtn.style.cursor = '';
      }
    });
  } catch (error) {
    console.error('[PurchaseLimit] Popup error:', error);
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  await applyPopupPurchaseLimits();

  document.addEventListener('cart:quantitychanged', async () => {
    await applyPopupPurchaseLimits();
  });
});
